import { get, set, del } from 'idb-keyval'
import {
    PersistedClient,
    Persister,
} from '@tanstack/react-query-persist-client'
import { normalizeArrayResponse } from '@/utils'

const collectionQueryKeys = new Set([
    'addresses',
    'bonuses',
    'employees',
    'equipments',
    'locations',
    'materials',
    'professions',
    'projects',
    'projects-tasks',
    'purchase-orders',
    'settings',
    'suppliers',
    'tasks',
])

export function createIDBPersister(idbValidKey: IDBValidKey = 'reactQuery') {
    return {
        persistClient: async (client: PersistedClient) => {
            // Deduplicate mutations by mutationKey
            const mutationMap = new Map();
            for (const mutation of client.clientState.mutations) {
                const key = JSON.stringify(mutation.mutationKey);
                mutationMap.set(key, mutation);
            }
            const dedupedMutations = Array.from(mutationMap.values());
            const newClient = { ...client, clientState: { ...client.clientState, mutations: dedupedMutations } };

            await set(idbValidKey, newClient)
        },
        restoreClient: async () => {
            const client = await get<PersistedClient>(idbValidKey)
            if (!client) return client

            // Repair old cached collection responses without deleting offline mutations.
            client.clientState.queries = client.clientState.queries.map(query => {
                const rootKey = query.queryKey?.[0]
                if (typeof rootKey !== 'string' || !collectionQueryKeys.has(rootKey)) {
                    return query
                }

                return {
                    ...query,
                    state: {
                        ...query.state,
                        data: query.state.data == null
                            ? query.state.data
                            : normalizeArrayResponse(query.state.data),
                    },
                }
            })

            return client
        },
        removeClient: async () => {
            await del(idbValidKey)
        },
    } as Persister
}